import AddIcon from 'assets/icons/add.svg';
import MinusIcon from 'assets/icons/minusIcon.svg';

import LockIcon from 'assets/icons/lockIcon.svg';
import { Dialog } from 'primereact/dialog';
import classes from './ndcAddModal.module.scss';

import {
  NDCEditFormDropDownResponseInterface,
  NDCFormFieldsTypes,
} from 'Interfaces/FactsInterfaces/drugInterfaces';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import {
  getFirstDayFromDateString,
  getFirstDayOfMonth,
  getNextMonthFirstDay,
  getOneBiggerDate,
  getOneSmallerDate,
  getTomorowsDate,
  DateConversionUtility,
} from 'utils/dateUtilities';
import { checkIfNDCStrategyAddEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import AddModal from './components/addModal/AddModal';
import FutureNdcAddedPopUp from './components/futureAddedPopUp/FutureAddedPopUp';
import NdcHistoryTable from '../ndcHistoryTable/NdcHistoryTable';
import { useNdcAddModal } from './useNdcAddModal';

const NdcHistoryEditModal = ({
  visibility,
  toggleVisibility,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
}) => {
  const tomorrowsDate = new Date();
  tomorrowsDate.setDate(tomorrowsDate.getDate() + 1);

  const {
    ndcFormDropDownData,
    isNcdTableLoading,
    isNdcUpdating,
    isAnyStrategySelected,
    handleStrategySelect,
    handleUnselectStrategy,
    allDropdownOptions,
    checkIfDropdownOptionDisabled,
    userModulesRoles,
    selectedNdcRowData,
    isNdcHistoryLoading,
    isHistoryVisible,
    initialNdcStrategyIndividualEditData,
    toggleHistoryVisibility,
    convertNdcFormDataToAllOptions,
    maxDateFromGivenAndTodays,
    errorDetails,
    ndcStrategyIndividualEditData,
    formUpdateMethods,
    formFieldsArrayConverter,
    selectedOption,
    addModalVisibility,
    toggleAddModalVisibility,
    handleNewStrategySelect,
    addModalHeading,
    setAddModalHeading,
    isNewNdcAddVisible,
    newlyAddedFutureNdcData,
    toggleNewNdcPopVisibility,
  } = useNdcAddModal();

  const DropDownItemTemplate = (option: { name: string; code: string }) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ marginRight: '0.6rem' }}>{option.name}</div>
        {!checkIfNDCStrategyAddEnabled(
          option.code as NDCFormFieldsTypes,
          userModulesRoles.facts,
          userModulesRoles
        ) && (
          <img
            src={LockIcon}
            alt={'Locked'}
            style={{ height: '17px', width: '17px', padding: 0 }}
          />
        )}
      </div>
    );
  };

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      header={`Add NDC - ${selectedNdcRowData?.NDC11} `}
      headerClassName={classes.modalHeader}
      visible={visibility}
      style={{ width: '55vw' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
    >
      <div className={classes.modalContainer}>
        <Divider className={classes.devider} />
        <div className={classes.updateTooltip}>
          <span className={classes.tooltipMessage}>
            * Fields for which start date is in future, will only be visible in future
          </span>
          <Dropdown
            options={allDropdownOptions()}
            optionDisabled={checkIfDropdownOptionDisabled}
            optionLabel="name"
            itemTemplate={DropDownItemTemplate}
            onChange={e => {
              handleStrategySelect(e.target.value.code);
            }}
            placeholder="Select strategy"
          />
        </div>

        {isAnyStrategySelected() ? (
          <>
            {ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData && (
              <>
                {formFieldsArrayConverter().map((fieldValues, index) => {
                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                      {fieldValues.selected && fieldValues.keyName !== 'PPSSC' ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem',
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <span>
                              {fieldValues.keyName === 'PPS'
                                ? 'PPS & PPS Reason'
                                : fieldValues.keyName === 'DPStrategy'
                                  ? 'Demand Planning'
                                  : 'Financial Segmentation'}
                            </span>
                            <img
                              style={{ cursor: 'pointer' }}
                              src={MinusIcon}
                              alt="Remove"
                              onClick={() => handleUnselectStrategy(fieldValues.keyName)}
                            />
                          </div>
                          <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
                            <div style={{ width: '50%' }}>
                              <div
                                style={{ display: 'flex', width: '100%', gap: '0.5rem' }}
                                className={classes.valuesContainer}
                              >
                                <Dropdown
                                  style={{ width: '100%' }}
                                  key={index}
                                  value={selectedOption(fieldValues.keyName, fieldValues.value)}
                                  options={
                                    convertNdcFormDataToAllOptions(
                                      ndcFormDropDownData as NDCEditFormDropDownResponseInterface
                                    )[fieldValues.keyName]
                                  }
                                  optionLabel="name"
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateValue(
                                      fieldValues.keyName as NDCFormFieldsTypes,
                                      e.target.value.code
                                    )
                                  }
                                  placeholder="Select strategy"
                                />
                                <Button
                                  outlined
                                  className={classes.historicalButton}
                                  style={{ border: '1px solid grey' }}
                                  // label="Add"
                                  onClick={() => {
                                    setAddModalHeading(fieldValues.keyName);
                                    toggleAddModalVisibility();
                                  }}
                                >
                                  <img src={AddIcon} alt="add icon" />
                                </Button>
                              </div>
                            </div>
                            <div style={{ width: '50%' }}>
                              {fieldValues.keyName === 'PPS' && (
                                <div
                                  style={{ display: 'flex', width: '100%', gap: '0.5rem' }}
                                  className={classes.valuesContainer}
                                >
                                  <Dropdown
                                    style={{ width: '100%' }}
                                    key={index}
                                    value={selectedOption(
                                      'PPSSC',
                                      ndcStrategyIndividualEditData.PPSSC.value
                                    )}
                                    options={
                                      convertNdcFormDataToAllOptions(
                                        ndcFormDropDownData as NDCEditFormDropDownResponseInterface
                                      ).PPSSC
                                    }
                                    optionLabel="name"
                                    onChange={e =>
                                      formUpdateMethods.handleUpdateValue(
                                        'PPSSC',
                                        e.target.value.code
                                      )
                                    }
                                    placeholder="Select strategy"
                                  />
                                  <Button
                                    outlined
                                    style={{ border: '1px solid grey' }}
                                    className={classes.historicalButton}
                                    // label="Add"
                                    onClick={() => {
                                      setAddModalHeading('PPSSC');
                                      toggleAddModalVisibility();
                                    }}
                                  >
                                    <img src={AddIcon} alt="add icon" />
                                  </Button>
                                </div>
                              )}
                            </div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            {/* Start Dates  */}
                            <div style={{ width: '100%' }}>
                              {!fieldValues.monthYearDates ? (
                                <Calendar
                                  style={{ width: '100%' }}
                                  className={classes.dateInput}
                                  // max date and min date validations are sensitive piece of code, please change it carefully and test it rigorously after it
                                  minDate={getTomorowsDate()}
                                  maxDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate ===
                                    initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                      .endDate
                                      ? undefined
                                      : getOneSmallerDate(
                                          DateConversionUtility.convertDBDateToLocal(
                                            ndcStrategyIndividualEditData[fieldValues.keyName]
                                              .endDate
                                          )!
                                        )
                                  }
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateStartDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              ) : (
                                <Calendar
                                  style={{ width: '100%' }}
                                  view="month"
                                  dateFormat="mm/yy"
                                  className={classes.dateInput}
                                  // max date and min date validations are sensitive piece of code, please change it carefully and test it rigorously after it
                                  minDate={getNextMonthFirstDay(new Date().toDateString())}
                                  maxDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate ===
                                    initialNdcStrategyIndividualEditData[fieldValues.keyName]
                                      .endDate
                                      ? undefined
                                      : getFirstDayOfMonth(
                                          new Date(
                                            ndcStrategyIndividualEditData[
                                              fieldValues.keyName
                                            ].endDate
                                          ).toDateString()
                                        )
                                  }
                                  onChange={e =>
                                    formUpdateMethods.handleUpdateStartDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    )
                                  }
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              )}
                            </div>

                            {/* End Dates */}
                            <div style={{ width: '100%' }}>
                              {!fieldValues.monthYearDates ? (
                                <Calendar
                                  style={{ width: '100%' }}
                                  className={classes.dateInput}
                                  minDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                      ? getOneBiggerDate(
                                          maxDateFromGivenAndTodays(
                                            DateConversionUtility.convertDBDateToLocal(
                                              ndcStrategyIndividualEditData[fieldValues.keyName]
                                                .startDate
                                            )!
                                          )
                                        )
                                      : getTomorowsDate()
                                  }
                                  onChange={e => {
                                    formUpdateMethods.handleUpdateEndDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    );
                                  }}
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              ) : (
                                <Calendar
                                  style={{ width: '100%' }}
                                  view="month"
                                  dateFormat="mm/yy"
                                  className={classes.dateInput}
                                  minDate={
                                    ndcStrategyIndividualEditData[fieldValues.keyName].startDate
                                      ? getFirstDayFromDateString(
                                          ndcStrategyIndividualEditData[fieldValues.keyName]
                                            .startDate
                                        )
                                      : getNextMonthFirstDay(new Date().toDateString())
                                  }
                                  onChange={e => {
                                    formUpdateMethods.handleUpdateEndDate(
                                      fieldValues.keyName,
                                      e.target.value as Date
                                    );
                                  }}
                                  value={DateConversionUtility.convertDBDateToLocal(
                                    ndcStrategyIndividualEditData[fieldValues.keyName].endDate
                                  )}
                                  disabled={fieldValues.datesDisabled ? true : false}
                                  showIcon
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '3rem',
              width: '100%',
              border: '1px solid grey',
              borderRadius: '0.3rem',
            }}
          >
            <span>Please select some strategy to edit</span>
          </div>
        )}

        {errorDetails.isError && (
          <div className={classes.errorDetails}>{`* ${errorDetails.errorDetails}`}</div>
        )}
        <div className={classes.updateButtonWrapper}>
          <Button
            onClick={toggleHistoryVisibility}
            outlined
            className={classes.historicalButton}
            label="Historical/Future values"
          />
          <Button
            loading={isNdcUpdating || isNdcHistoryLoading}
            disabled={
              !isAnyStrategySelected() || isNdcUpdating || isNcdTableLoading || isNdcHistoryLoading
            }
            className={classes.updateButton}
            onClick={formUpdateMethods.handleUpdateButtonClick}
          >
            Update
          </Button>
        </div>

        {isHistoryVisible && <NdcHistoryTable />}
        {isNewNdcAddVisible && (
          <FutureNdcAddedPopUp
            visibility={isNewNdcAddVisible}
            toggleVisibility={toggleNewNdcPopVisibility}
            addedFutureNDCData={newlyAddedFutureNdcData}
          />
        )}
      </div>
      {addModalVisibility && (
        <AddModal
          fieldType={addModalHeading as NDCFormFieldsTypes}
          modalHeading={addModalHeading as string}
          handleNewStrategySelect={handleNewStrategySelect}
          visibility={addModalVisibility}
          toggleVisibility={toggleAddModalVisibility}
        />
      )}
      {/* </div> */}
    </Dialog>
  );
};

export default observer(NdcHistoryEditModal);
